import { apiSimple } from './api'

/**
 * Busca a URL de autorização da 99Food para o app_shop_id informado
 */
export const getAuthorizationUrl = async (appShopId) => {
  try {
    const response = await apiSimple.get('/api/admin/99food/auth/url', {
      params: { appShopId }
    })
    return response.data
  } catch (error) {
    console.error('Erro ao buscar URL de autorização 99Food:', error.response?.data || error.message)
    throw error
  }
}

/**
 * Inicializa (busca e salva) o token de uma loja
 * Deve ser chamado após o franqueado autorizar no portal 99Food
 */
export const initToken = async (appShopId, storeId) => {
  try {
    const response = await apiSimple.post('/api/admin/99food/token/init', {
      appShopId,
      storeId
    })
    return response.data
  } catch (error) {
    console.error('Erro ao inicializar token 99Food:', error.response?.data || error.message)
    throw error
  }
}

/**
 * Verifica se a loja já tem token ativo na 99Food
 */
export const getTokenStatus = async (storeId) => {
  try {
    const response = await apiSimple.get('/api/admin/99food/auth/status', {
      params: { storeId }
    })
    return response.data
  } catch (error) {
    console.error('Erro ao verificar status do token 99Food:', error.response?.data || error.message)
    throw error
  }
}
